import React from 'react';
import moment from 'moment';
import { SaldoContribuicoesFaelceEntidade } from '@entidades';

import { Badge, Box } from '@intech/web-ui';

interface IProps {
  saldo: SaldoContribuicoesFaelceEntidade | undefined;
}

export const SaldoAcomulado: React.FC<IProps> = ({
  saldo
}) => {

  function ToMoney(Valor: number | undefined, FractionDigits = -1) {
    var options: any = {
      minimumFractionDigits: 2
    }
    if (FractionDigits > -1) {
      options = {
        minimumFractionDigits: FractionDigits,
        maximumFractionDigits: FractionDigits
      }
    }
    if (Valor === undefined)
      return 0;
    return (
      Valor.toLocaleString('pt-br', options)
    );
  }

  if (saldo === undefined) {
    return null;
  }

  return (
    <Box title={"Saldo Acumulado Atualizado"} badgeText={`Referência em ${moment(saldo.Referencia, "DD/MM/YYYY").format("DD/MM/YYYY")}`}>
      <div className={"table-responsive"}>
        <table className={"table table-striped table-sm"}>
          <tbody>
            <tr>
              <td style={{ "textAlign": "left" }}>
                {""}
              </td>
              <td style={{ "textAlign": "right" }}>
                {"Em Cotas"}
              </td>
              <td style={{ "textAlign": "right" }}>
                {"Em Reais"}
              </td>
            </tr>

            <tr>
              <td style={{ "textAlign": "left" }}>
                {"Subconta Participante"}
              </td>
              <td style={{ "textAlign": "right" }}>
                {ToMoney(saldo.QtCotaParticipante, 8)}
              </td>
              <td style={{ "textAlign": "right" }}>
                R$ {ToMoney(saldo.ContribParticipante, 2)}
              </td>
            </tr>

            <tr>
              <td style={{ "textAlign": "left" }}>
                {"Subconta Patrocinadora"}
              </td>
              <td style={{ "textAlign": "right" }}>
                {ToMoney(saldo.QtCotaPatrocinadora, 8)}
              </td>
              <td style={{ "textAlign": "right" }}>
                R$ {ToMoney(saldo.ContribPatrocinadora, 2)}
              </td>
            </tr>

            <tr>
              <td style={{ "textAlign": "left" }}>
                {"Valores Portados"}
              </td>
              <td style={{ "textAlign": "right" }}>
                {ToMoney(saldo.QtCotaPortabilidade, 8)}
              </td>
              <td style={{ "textAlign": "right" }}>
                R$ {ToMoney(saldo.ContribPortabilidade, 2)}
              </td>
            </tr>

            <tr>
              <td style={{ "textAlign": "left" }}>
                <b>
                  {"TOTAL"}
                </b>
              </td>
              <td style={{ "textAlign": "right" }}>
                <b>
                  {ToMoney(saldo.QtCotaTotal, 8)}
                </b>
              </td>
              <td style={{ "textAlign": "right" }}>
                <b>
                  R$ {ToMoney(saldo.ContribTotal, 2)}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Badge type={"warning"}>
        {`Valor da Cota em ${moment(saldo.Referencia, "DD/MM/YYYY").format("DD/MM/YYYY")}: ${ToMoney(saldo.Cota, 8)}`}
      </Badge>
    </Box>
  );
}